import { render, staticRenderFns } from "./createColis.vue?vue&type=template&id=91cee6e0&"
import script from "./createColis.vue?vue&type=script&lang=js&"
export * from "./createColis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports